'use client'
import { useApolloClient } from '@apollo/client'
import { useEffect } from 'react'

import { doLogoutAction } from '@/actions/auth'
import { STORAGE_REFRESH_TOKEN_KEY, STORAGE_TOKEN_KEY, STORAGE_UID_KEY } from '@/constants'
import { updateLocalToken } from '@/service/token'

// Clean auth info if clean query param is present
function CleanAuthInfo() {
  const ac = useApolloClient()
  useEffect(() => {
    const url = new URL(location.href)
    if (!url.searchParams.has('clean')) {
      return 
    }
    updateLocalToken('')
    localStorage.removeItem(STORAGE_TOKEN_KEY)
    localStorage.removeItem(STORAGE_REFRESH_TOKEN_KEY)
    localStorage.removeItem(STORAGE_UID_KEY)
    ac.resetStore()
    doLogoutAction().then(() => {
      location.replace('/auth/github')
    })
  }, [])
  return null
}

export default CleanAuthInfo